var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppMerchQrCode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "279px",
    height: "279px",
    viewBox: "0 0 279 279",
    enableBackground: "new 0 0 279 279",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 279,
    height: 279,
    fill: "rgb(255,255,255)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9,9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(81,0) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(90,0) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(99,0) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(108,0) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(117,0) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(135,0) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(162,0) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(171,0) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72,9) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(117,9) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(126,9) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144,9) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(153,9) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(162,9) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(180,9) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(90,18) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(99,18) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(135,18) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(153,18) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(171,18) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(180,18) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(99,27) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(108,27) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(117,27) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(126,27) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144,27) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(171,27) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(180,27) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(117,36) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(126,36) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144,36) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(162,36) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72,45) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81,45) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(99,45) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(117,45) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(162,45) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(171,45) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72,54) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(90,54) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(108,54) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(126,54) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144,54) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(162,54) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(180,54) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72,63) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(90,63) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(135,63) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(153,63) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(162,63) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36,72) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45,72) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54,72) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63,72) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(90,72) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(126,72) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(135,72) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(162,72) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(171,72) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(198,72) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(207,72) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(243,72) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,81) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18,81) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27,81) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45,81) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63,81) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72,81) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81,81) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(99,81) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(117,81) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(126,81) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(135,81) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144,81) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(153,81) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(171,81) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(180,81) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(189,81) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(198,81) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(207,81) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(216,81) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(243,81) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(252,81) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9,90) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18,90) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27,90) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36,90) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54,90) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(90,90) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(117,90) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144,90) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(180,90) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(189,90) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(225,90) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(234,90) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(252,90) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,99) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9,99) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27,99) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36,99) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45,99) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81,99) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(99,99) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(108,99) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(135,99) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144,99) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(189,99) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(243,99) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(252,99) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,108) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18,108) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36,108) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45,108) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54,108) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63,108) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81,108) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(90,108) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(108,108) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(117,108) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(126,108) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144,108) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(171,108) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(207,108) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(225,108) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(252,108) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,117) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27,117) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45,117) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63,117) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72,117) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81,117) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(90,117) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(99,117) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(108,117) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(117,117) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(135,117) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(153,117) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(198,117) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(216,117) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(234,117) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(252,117) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45,126) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54,126) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63,126) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(90,126) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(99,126) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(108,126) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(117,126) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(153,126) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(180,126) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(198,126) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(216,126) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(252,126) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,135) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27,135) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45,135) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63,135) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81,135) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(90,135) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(126,135) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(135,135) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(162,135) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(180,135) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(207,135) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(225,135) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(243,135) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(252,135) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9,144) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18,144) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27,144) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54,144) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63,144) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81,144) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(108,144) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(126,144) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(135,144) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(153,144) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(171,144) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(180,144) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(189,144) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(207,144) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(243,144) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,153) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9,153) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18,153) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27,153) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(90,153) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(99,153) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(108,153) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(126,153) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(135,153) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(153,153) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(162,153) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(171,153) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(189,153) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(198,153) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(216,153) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(252,153) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18,162) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45,162) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54,162) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63,162) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72,162) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(90,162) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(126,162) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(171,162) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(207,162) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(225,162) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(234,162) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(252,162) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27,171) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36,171) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45,171) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63,171) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81,171) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(117,171) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(126,171) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(135,171) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144,171) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(171,171) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(180,171) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(207,171) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(216,171) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(243,171) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(252,171) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,180) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9,180) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18,180) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54,180) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72,180) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81,180) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(117,180) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(126,180) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(162,180) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(180,180) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(189,180) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(198,180) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(207,180) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(216,180) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(243,180) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72,189) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(90,189) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(108,189) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144,189) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(153,189) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(180,189) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(216,189) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(234,189) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(243,189) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(252,189) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72,198) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(99,198) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(108,198) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(135,198) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(153,198) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(162,198) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(171,198) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(180,198) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(198,198) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(216,198) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(252,198) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72,207) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81,207) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(99,207) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(126,207) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(135,207) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144,207) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(171,207) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(180,207) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(216,207) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(225,207) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(243,207) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72,216) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(135,216) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144,216) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(153,216) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(171,216) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(180,216) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(189,216) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(198,216) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(207,216) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(216,216) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(243,216) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(252,216) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81,225) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(90,225) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(99,225) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(135,225) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(162,225) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(207,225) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(225,225) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(234,225) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(243,225) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81,234) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(117,234) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144,234) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(162,234) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(171,234) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(180,234) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(189,234) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(234,234) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(243,234) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(252,234) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(90,243) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(108,243) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(126,243) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144,243) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(189,243) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(207,243) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(243,243) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(252,243) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(99,252) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(117,252) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(126,252) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(162,252) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(171,252) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(180,252) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(189,252) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(216,252) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(243,252) scale(0.019,0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M250,0c138.077,0,250,111.93,250,250c0,138.077-111.923,250-250,250C111.93,500,0,388.077,0,250C0,111.93,111.93,0,250,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0) scale(0.61764705882353, 0.61764705882353)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M51,16c-19.299,0-35,15.701-35,35s15.701,35,35,35s35-15.701,35-35S70.299,16,51,16z"
  }), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M51,1C23.387,1,1,23.387,1,51s22.387,50,50,50s50-22.387,50-50S78.613,1,51,1z M51,86c-19.299,0-35-15.701-35-35 s15.701-35,35-35s35,15.701,35,35S70.299,86,51,86z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(198,0) scale(0.61764705882353, 0.61764705882353)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M51,16c-19.299,0-35,15.701-35,35s15.701,35,35,35s35-15.701,35-35S70.299,16,51,16z"
  }), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M51,1C23.387,1,1,23.387,1,51s22.387,50,50,50s50-22.387,50-50S78.613,1,51,1z M51,86c-19.299,0-35-15.701-35-35 s15.701-35,35-35s35,15.701,35,35S70.299,86,51,86z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,198) scale(0.61764705882353, 0.61764705882353)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M51,16c-19.299,0-35,15.701-35,35s15.701,35,35,35s35-15.701,35-35S70.299,16,51,16z"
  }), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M51,1C23.387,1,1,23.387,1,51s22.387,50,50,50s50-22.387,50-50S78.613,1,51,1z M51,86c-19.299,0-35-15.701-35-35 s15.701-35,35-35s35,15.701,35,35S70.299,86,51,86z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18,18) scale(0.26470588235294, 0.26470588235294)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(216,18) scale(0.26470588235294, 0.26470588235294)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18,216) scale(0.26470588235294, 0.26470588235294)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppMerchQrCode);
export default __webpack_public_path__ + "static/media/AppMerchQRCode.7f6e8de1731f2749768444db82d0cc7f.svg";
export { ForwardRef as ReactComponent };